export default __webpack_public_path__ + "static/media/consumption.72ad8927.png";